module.exports = __webpack_public_path__ + "img/difficulty.5013ac75.png";